import { render, staticRenderFns } from "./ReplaceMediaDialog.vue?vue&type=template&id=512f224f&scoped=true"
import script from "./ReplaceMediaDialog.vue?vue&type=script&lang=js"
export * from "./ReplaceMediaDialog.vue?vue&type=script&lang=js"
import style0 from "./ReplaceMediaDialog.vue?vue&type=style&index=0&id=512f224f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f224f",
  null
  
)

export default component.exports